import { render, staticRenderFns } from "./importacaoStatus.vue?vue&type=template&id=8f644cd4"
import script from "./importacaoStatus.vue?vue&type=script&lang=js"
export * from "./importacaoStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports